import { PartnerStateModel } from "../Dto/PartnerStateModel";
import { Partner } from "../Dto/PartnerModel";
import { PaginationInfo } from "../Dto/PartnerSearchResponse";
import { PartnerSearchRequest } from "../Dto/PartnerSearchRequest";
import { Injectable, signal, computed } from "@angular/core";

const initialState: PartnerStateModel = {
  data: [],
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    pages: 0,
  },
  searchParams: {
    page: 1,
    limit: 10,
  },
  loading: false,
  error: null,
};

@Injectable({ providedIn: "root" })
export class PartnerState {
  private readonly state = signal<PartnerStateModel>(initialState);
  public readonly data = computed(() => this.state().data);
  public readonly pagination = computed(() => this.state().pagination);
  public readonly searchParams = computed(() => this.state().searchParams);
  public readonly loading = computed(() => this.state().loading);
  public readonly error = computed(() => this.state().error);

  setPartners(data: Partner[], pagination: PaginationInfo): void {
    this.state.update((state) => ({
      ...state,
      data,
      pagination,
      loading: false,
      error: null,
    }));
  }

  setSearchParams(params: PartnerSearchRequest): void {
    this.state.update((state) => ({
      ...state,
      searchParams: params,
    }));
  }

  setLoading(loading: boolean): void {
    this.state.update((state) => ({ ...state, loading }));
  }

  setError(error: string | null): void {
    this.state.update((state) => ({ ...state, error }));
  }

  removePartnerFromState(partnerId: string): void {
    this.state.update((state) => ({
      ...state,
      data: state.data.filter((partner) => partner.id !== partnerId),
      pagination: {
        ...state.pagination,
        total: state.pagination.total - 1,
      },
    }));
  }

  addPartnerToState(partner: Partner): void {
    this.state.update((state) => ({
      ...state,
      data: [partner, ...state.data],
      pagination: {
        ...state.pagination,
        total: state.pagination.total + 1,
      },
    }));
  }

  updatePartnerInState(partner: Partner): void {
    this.state.update((state) => ({
      ...state,
      data: state.data.map((inst) =>
        (() => {
          if (inst.id === partner.id) {
            return partner;
          }
          return inst;
        })(),
      ),
      loading: false,
      error: null,
    }));
  }
}
